import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { IResponse } from "../interfaces/IResponse";

export interface Configuration {
  FX_APPROVAL: string;
  RM_CONFIRMATION: string;
  FX_EXPORT: string;
  BATCH_PRICE_OVERRIDE: string;
  batch_price_override_min_limit: string;
  batch_price_override_max_limit: string;
}

@Injectable( {
  providedIn: 'root'
} )
export class ConfigurationService {
  private httpClient = inject(HttpClient);

  SERVER_URL = environment.apiUrl;
  revenueManagerConfigurationDTO = new ReplaySubject();
  decimalPoints = 0;
  currency = '$';

  getDashboardFilters(): Observable<IResponse> {
    return this.httpClient.get( this.SERVER_URL + '/dashboard/filters' );
  }

  getFilters( body: { filters: { [key: string]: any[] } } ): Observable<IResponse> {
    return this.httpClient.post( this.SERVER_URL + '/revenue-manager/filters', body  );
  }

  getStrategyPriceOverrideFilters( body: { filters: { [key: string]: any[] } } ): Observable<IResponse> {
    return this.httpClient.post( this.SERVER_URL + '/bulk-change/filters',
      { filters: body.filters ?? {} } );
  }

  getProperty(): Observable<IResponse> {
    return this.httpClient.get( this.SERVER_URL + '/dashboard/filters' );
  }

  getClusterPricingFilters( body: Record<string, any> ): Observable<IResponse> {
    return this.httpClient.post( this.SERVER_URL + '/auto-pilot/filters', body );
  }
}
